import { useState } from 'react'
import Box from '@mui/joy/Box'
import Button from '@mui/joy/Button'
import { ErrorAlert } from './ui/ErrorAlert'
import { PrimaryAlert } from './ui/PrimaryAlert'
import Modal from '@mui/joy/Modal'
import ModalOverflow from '@mui/joy/ModalOverflow'
import ModalDialog from '@mui/joy/ModalDialog'
import ModalClose from '@mui/joy/ModalClose'
import Sheet from '@mui/joy/Sheet'
import AspectRatio from '@mui/joy/AspectRatio'
import { MediaContainer } from './MediaContainer'
import { SchedulerUpdateForm } from './SchedulerUpdateForm'
import { CampaignAPI } from '../api/CampaignAPI'
import { Loading } from './ui/Loading'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs'
import _ from 'lodash'

const ModalBody = ({
    asset,
    onSubmit,
    onDelete,
    onEdit,
    onValidationError,
    readOnly,
}) => {
    return (
        <Box sx={{ display: 'flex', gap: 2 }}>
            <Box
                sx={{
                    display: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 2,
                }}
            >
                <Sheet
                    variant="soft"
                    sx={{
                        display: 'flex',
                        flex: 1,
                        alignItems: 'center',
                        width: 400,
                        p: 4,
                    }}
                >
                    <MediaContainer url={asset.source_url} />
                </Sheet>
                <Box sx={{ display: 'flex' }}>
                    <Button
                        size="lg"
                        color="primary"
                        variant="outlined"
                        onClick={onEdit}
                        disabled={readOnly}
                    >
                        Edit
                    </Button>
                </Box>
            </Box>
            <Box sx={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
                <SchedulerUpdateForm
                    asset={asset}
                    onSubmit={onSubmit}
                    onDelete={onDelete}
                    onValidationError={onValidationError}
                    readOnly={readOnly}
                />
            </Box>
        </Box>
    )
}

export const AssetModal = ({
    isOpen,
    campaignId,
    asset,
    onAssetChanged,
    onClose,
}) => {
    const UPDATE = 'Updating...'
    const DELETE = 'Deleting...'
    const [action, setAction] = useState(null)
    const [alerts, setAlerts] = useState([])
    const navigate = useNavigate()

    const alertEls = alerts.map((alert) => (
        <>
            <ErrorAlert>Fix {alert}</ErrorAlert>
        </>
    ))

    const isDateFuture = (dt) => {
        return dayjs().isBefore(dt)
    }

    const shouldDisable = () => {
        if (asset && asset.schedule_date) {
            return !isDateFuture(asset.schedule_date)
        }

        return false
    }

    const deleteAsset = () => {
        setAction(DELETE)
        CampaignAPI.deleteAsset(campaignId, asset.id).then((response) => {
            console.log(response)
            onAssetChanged()
        })
    }

    const updateAsset = ({ caption, date, time, publishTo }) => {
        setAlerts([])
        setAction(UPDATE)
        let schedule_date = date
            .hour(time.hour())
            .minute(time.minute())
            .second(time.second())
            .toISOString()
        const assetObj = {
            caption,
            schedule_date,
            publish_to: _.flatMap(publishTo, (obj) => obj.canonicalName),
        }

        CampaignAPI.updateAsset(campaignId, asset.id, assetObj).then(
            (response) => {
                console.log(response)
                onAssetChanged()
            }
        )
    }

    const handleValidationError = (fieldKeys) => {
        setAlerts(fieldKeys)
    }

    const handleClose = () => {
        setAlerts([])
        onClose()
    }

    let body = (
        <ModalBody
            asset={asset}
            onDelete={deleteAsset}
            onSubmit={updateAsset}
            onEdit={() =>
                navigate(
                    `/merchant/campaigns/${campaignId}/assets/${asset.id}/edit`
                )
            }
            onValidationError={handleValidationError}
            readOnly={shouldDisable()}
        />
    )
    if (action !== null) {
        body = <Loading message={action} />
    }

    return (
        <Modal open={isOpen} onClose={handleClose} size="lg" variant="solid">
            <ModalOverflow>
                <ModalDialog>
                    <ModalClose />
                    <Box
                        sx={{
                            mt: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        }}
                    >
                        {alertEls}
                        {shouldDisable() && (
                            <PrimaryAlert>
                                This item has been scheduled for a past time and
                                cannot be edited.
                            </PrimaryAlert>
                        )}
                    </Box>
                    {body}
                </ModalDialog>
            </ModalOverflow>
        </Modal>
    )
}
